
<template>
	<div class="box" style="padding:0px">
	  <div class="boxTitle" style="margin:15px">关口代表企业</div>
	  <div class="echart">
	   <dv-scroll-board :config="config" style="width:100%;height:30vh" />
	  </div>
	</div>
</template>

<script>
	export default {
		name: "Two",
		data() {
			return {
        config:{

            data: [
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
              ['深圳关口', '东风财富有限公司'],
            ],
            columnWidth: [200, 300],
            align: ['left'],
            rowNum: 10,
            headerBGC: '#1981f6',
            headerHeight: 45,
            oddRowBGC: 'rgba(0, 44, 81, 0.8)',
            evenRowBGC: '#0D3769'
        },
		}
	}
}
</script>

<style>
  .echart{
    display:flex;
    justify-content:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/left/two.vue